import { render } from "./HorizontalBarChartTemplate.vue?vue&type=template&id=5ece53fa"
import script from "./HorizontalBarChartTemplate.vue?vue&type=script&lang=js"
export * from "./HorizontalBarChartTemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/insights/chart-building/chart_templates/HorizontalBarChartTemplate.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5ece53fa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5ece53fa', __exports__)) {
    api.reload('5ece53fa', __exports__)
  }
  
  module.hot.accept("./HorizontalBarChartTemplate.vue?vue&type=template&id=5ece53fa", () => {
    api.rerender('5ece53fa', render)
  })

}


export default __exports__